module.exports = __webpack_public_path__ + "img/MC_ID_Club.93d9ca1f.png";